function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512.301 16.287C748.76-36.254 964.318 54.932 1019 57.261v617.983c-82.85 68.981-414.96 142.584-567.859 32.357-180.551-130.162-208.724-76.448-324.287-130.85-163.59-77.011-189.168-269.879 44.091-326.059C477.364 176.891 344.339 53.609 512.301 16.287z",
  fill: "#fef0f1"
});

function SvgOpenedCakeBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 764,
    width: 1019
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9Ijc2NCIgdmlld0JveD0iMCAwIDEwMTkgNzY0IiB3aWR0aD0iMTAxOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJtNTEyLjMwMSAxNi4yODcyYzIzNi40NTktNTIuNTQxNSA0NTIuMDE3IDM4LjY0NDYgNTA2LjY5OSA0MC45NzM4djYxNy45ODNjLTgyLjg1IDY4Ljk4MS00MTQuOTYgMTQyLjU4NC01NjcuODU5IDMyLjM1Ny0xODAuNTUxLTEzMC4xNjItMjA4LjcyNC03Ni40NDgtMzI0LjI4Ny0xMzAuODUtMTYzLjU4OTktNzcuMDExLTE4OS4xNjgxLTI2OS44NzkgNDQuMDkxLTMyNi4wNTkgMzA2LjQxOS03My44MDEgMTczLjM5NC0xOTcuMDgzNCAzNDEuMzU2LTIzNC40MDQ4eiIgZmlsbD0iI2ZlZjBmMSIvPjwvc3ZnPg==";
export { SvgOpenedCakeBg as ReactComponent };